/**
 * @author Andrés Ferreira
 * @Copyright (c) Infotrack. All rights reserved.
 */
import ProveedorEstado from '@infotrack/presentacion-componentes/proveedorEstado';
import React from 'react';
import FormularioFlujosCV from './controladorVista/formularioFlujosCV';
import TablaFlujosCV from './controladorVista/tablaFlujosCV';
import { estadoIncial, reductor } from './reductorFlujos';

const Flujos: React.FunctionComponent = () => (
    <ProveedorEstado estadoInicial={estadoIncial} reductor={reductor}>
        <TablaFlujosCV />
        <FormularioFlujosCV />
    </ProveedorEstado>
);

export default Flujos;
